// extracted by mini-css-extract-plugin
export default {"followBtn":"FollowButton_followBtn__k0LA2","followBtnHeart":"FollowButton_followBtnHeart__o9iZo","followBtnHeartActive":"FollowButton_followBtnHeartActive__hVcol"};